/**
 * Created by Victor Rojo on 1/9/17.
 */
import { Component, OnInit }        from '@angular/core';
import { FormGroup, FormControl,
         FormBuilder, Validators }  from '@angular/forms';
import { ActivatedRoute }           from '@angular/router';
import { NotificationsService }     from 'angular2-notifications';

import { AuthService }  from '../auth.service';
import { Credential }   from "../credential";
import { I18NService }  from "../../i18n/i18n.service";

@Component({
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.css'],
})
export class ActivateComponent implements OnInit{

  activateForm: FormGroup;
  isBusy = false;
  public toastOptions = {
    position: ["top", "right"],
    timeOut: 3000,
    theClass: "bg-teal",
    lastOnBottom: true,
    showProgressBar: true,
    pauseOnHover: false,
  };
  private token:string;
  private login:string;

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private i18nService: I18NService,
              private notificationService: NotificationsService) {
    let pattern = /^[A-Za-z0-9\S\*]*$/;
    this.activateForm = fb.group({
      'password' : [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(pattern)])],
    })
  }

  ngOnInit():void {
    this.token = this.activatedRoute.snapshot.queryParams["token"];
    this.login = this.activatedRoute.snapshot.queryParams["login"];
  }

  activate():void{
    let data = {
      password: this.activateForm.controls["password"].value,
      token: this.token
    };
    if ( this.activateForm.valid ) {
      this.isBusy = true;
      this.authService.activate(data)
        .then(res => {
          let credential = new Credential(this.login, data.password);
          this.authService.login(credential, false)
            .then( response => {
              this.isBusy = false;
            })
            .catch(error => {
              this.isBusy = false;
            });
          this.isBusy = false;
        })
        .catch( error => {
          this.isBusy = false;
          this.notificationService.error(
            this.i18nService.get("error"),
            this.i18nService.get("cantActivateAccount")
          );
        });
    }
  }
}
